import { useContext, useMemo } from 'react';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';
import { SourcePageTrackerContext } from '@/context/sourcePageTracker/sourcePageTrackerProvider';
import DorsaImage from '@/components/dorsaImage/DorsaImage';
import ContentCardBadges from '@/app/community/components/ContentCardBadges';
import StatefulLink from '@/components/StatefulLink';
import useSourcePageTracker from '@/context/sourcePageTracker/useSourcePageTracker';

export interface BigVideoListCardProps {
    id: string;
    horizontalPoster: string;
    alt: string;
    actionDestination: string;
    isSingleBanner?: boolean;
    cardClassName?: string;
    isExclusive?: boolean;
    isComingSoon?: boolean;
}

function BigVideoListCard({
    // title,
    id,
    horizontalPoster,
    alt,
    actionDestination,
    isSingleBanner,
    cardClassName,
    isExclusive,
    isComingSoon
}: BigVideoListCardProps) {
    const { sourcePageData } = useSourcePageTracker();

    const relativatedLink = useMemo(() => {
        return actionDestination.replace(process.env.NEXT_PUBLIC_DOMAIN, '');
    }, [actionDestination]);

    return (
        <StatefulLink
            href={relativatedLink}
            state={sourcePageData}
            className={`big-video-list-card-container ${isSingleBanner ? 'single-banner' : ''} `}
            id={id}>
            {/*<div className="big-video-list-card-gradient-bg"></div>*/}
            <DorsaImage
                src={horizontalPoster}
                className={`big-video-list-card-image ${cardClassName}`}
                alt={alt}
                config={{
                    shape: IMAGE_SHAPES.HORIZONTAL,
                    size: isSingleBanner ? IMAGE_SIZES.SIZE_4 : IMAGE_SIZES.SIZE_3
                }}
            />
            <ContentCardBadges
                isExclusive={isExclusive}
                isComingSoon={isComingSoon}
                size={'horizontal-large'}
            />
            {/*<h2 className="big-video-list-card-title">{title}</h2>*/}
        </StatefulLink>
    );
}

export default BigVideoListCard;
